<div class="my-5">
  @if (isLoading) {
  <div class="loader position-relative">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  } @else if (isConfirmed) {
  <div class="buttons-container">
    <button class="btn btn-outline-primary" (click)="confirmResetReservation(true)">Cancelar reserva</button>
    <button class="btn btn-primary" (click)="ambassadorlogout()">Cerrar sesión</button>
  </div>
  } @else if (isCancelled) {
  <button class="btn btn-outline-primary" (click)="confirmResetReservation(false)">Volver al calendario</button>
  }
</div>
